<template>
  <v-data-table
    :headers="[
      { value: 'action', sortable: false },
      { text: '', value: 'hidden', class: 'condensed', sortable: false, },
      { text: 'Name', value: 'name' },
      { text: 'Product Count', value: 'productCount' },
      { text: 'User Accounts', value: 'userCount' },
      { text: 'Review Score', value: 'scoreAverage' },
      { text: 'Weighted Score', value: 'scoreWeighted' },
    ]"
    :items="organizations"
    :item-class="(item) => item.hidden ? 'org-hidden' : ''"
    :loading="loading"
    sort-by="createdAt"
    show-expand
  >
    <template #top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Organizations</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
        <v-spacer />
        <button
          class="default-btn blue mb-5"
          @click="$emit('startCreateEdit')"
        >Create Organization</button>
      </v-toolbar>

      <p class="help mx-5">
        You can create new organizations here, which individual loan products will be attached to. To add a user to an organization, which allows a non-admin to manage all aspects of an organization (products/leads/reviews/etc.), you can do so from the user management page. Give the user a 'lender' role and attach them to the desired organization in the user edit form.
      </p>

      <hr class="section-divider condensed" />
    </template>

    <template #header.scoreWeighted>
      Weighted Score
      <v-tooltip bottom color="black">
        <template v-slot:activator="{ on }">
          <v-icon color="primary" v-on="on">mdi-information</v-icon>
        </template>
        <span>
          This is a computed score not displayed to users. It is calculated based on the review score of the organization and how many reviews they've recieved.
        </span>
      </v-tooltip>
    </template>

    <template #item.hidden="{ value }">
      {{ value ? 'hidden' : '' }}
    </template>

    <template #item.name="{ value, item }">
      <router-link
        class="default-btn link small"
        :to="{ name: 'OrganizationDashboard', params: { organizationId: item.id }}"
      >{{ value }}</router-link>
    </template>

    <template #item.scoreAverage="{ value }">
      <star-rating
        v-if="value"
        :rating="value"
        :editable="false"
        justify="flex-start" />
      <span v-else>N/A</span>
    </template>

    <template #item.scoreWeighted="{ value }">
      {{ value ? value.toFixed(4) : 'N/A' }}
    </template>

    <template #expanded-item="{ headers, item }">
      <td class="pa-2" :colspan="headers.length">
        <OrganizationUsersList
          :organization="item" :users="item.users"
          :confirmingToggle="confirmingToggle"
          @removedUser="$emit('removedUser', $event)"
          @toggleHidden="$emit('toggleHidden', item)"/>
      </td>
    </template>

    <template #item.actions="{ item }">
      <div class="button-group">
        <button
          class="default-btn text text-blue minimal"
          @click="$emit('edit', item)"
        ><v-icon color="inherit">mdi-pen</v-icon></button>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import OrganizationUsersList from './OrganizationUsersList'

export default {
  name: 'AdminOrganizationsTable',
  components: {
    OrganizationUsersList,
  },
  props: {
    organizations: Array,
    loading: {
      type: Boolean,
      default: false,
    },
    confirmingToggle: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .condensed {
    padding: 0 !important;
  }

  tr.org-hidden {
    background-color: #66666644;

    td:nth-child(3) {
      padding: 0 !important;
    }
  }
}
</style>
